$(document).ready(function ()
{
  if ($('.o-js-cancel_investment').length)
  {
    $('a:not(.o-js-cancel_investment_except)').each(function() {
      let path = $(this).attr('href');

      $(this).attr('data-remote', true);
      $(this).attr('href', '/portefeuilles/cancel_investment?path=' + path);
      $(this).attr('data-path', path);
    });
  }
});
